import { PUT_TASKS, ADD_TASK, PATCH_TASK } from './action';

const initialState = 'empty';

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case PATCH_TASK:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ...action.payload,
          unsaved:  true,
        }
      }

    case ADD_TASK:
      console.log('w akcji');
      return { 
        ...state, 
        'temporaryTask':  action.payload,
      }

    case PUT_TASKS:
        return action.payload 
    default: {
      return state;
    }
  }
};

export default reducer;
